import React, { useState } from 'react';
import { Eye, EyeOff, Check, X } from 'lucide-react';

const PasswordInput = ({ 
  value, 
  onChange, 
  placeholder = "Password", 
  showRequirements = false,
  className = "",
  ...props 
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [touched, setTouched] = useState(false);

  // Password validation checks
  const hasMinLength = value.length >= 8;
  const hasLetter = /[A-Za-z]/.test(value);
  const hasNumber = /\d/.test(value);
  const isValid = hasMinLength && hasLetter && hasNumber;

  const handleChange = (e) => {
    onChange(e);
    if (!touched) setTouched(true);
  };

  const RequirementItem = ({ met, children }) => (
    <div className={`flex items-center text-sm ${met ? 'text-green-600' : 'text-gray-500'}`}>
      {met ? <Check size={16} className="mr-2" /> : <X size={16} className="mr-2" />}
      {children}
    </div>
  );

  return (
    <div>
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={handleChange}
          onBlur={() => setTouched(true)}
          placeholder={placeholder}
          className={`w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent ${
            touched && !isValid ? 'border-red-500' : ''
          } ${className}`}
          {...props}
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>
      
      {showRequirements && (touched || value.length > 0) && (
        <div className="mt-2 p-3 bg-gray-50 rounded-md">
          <div className="text-sm font-medium text-gray-700 mb-2">Password Requirements:</div>
          <div className="space-y-1">
            <RequirementItem met={hasMinLength}>
              At least 8 characters
            </RequirementItem>
            <RequirementItem met={hasLetter}>
              Contains at least one letter
            </RequirementItem>
            <RequirementItem met={hasNumber}>
              Contains at least one number
            </RequirementItem>
          </div>
        </div>
      )}
      
      {touched && !isValid && value.length > 0 && !showRequirements && (
        <div className="mt-1 text-sm text-red-600">
          Password must be at least 8 characters and contain both letters and numbers
        </div>
      )}
    </div>
  );
};

export default PasswordInput;